export function preUrlHandler(prevUrl: string) {
  const editAccountUrlRe = new RegExp('/users/[0-9A-Z].*/update');
  if (prevUrl && editAccountUrlRe.test(prevUrl)) {
    return '/users/all';
  } else {
    return prevUrl;
  }
}
